import type {IconColorVariant} from './types';

type Props = {
  readonly variant?: IconColorVariant;
} & React.ComponentPropsWithRef<'svg'>;

function SuccessFillIcon({variant = 'colored', ...props}: Props): JSX.Element {
  let circle = '#008571';
  let path = '#FFF';
  if (variant === 'white') {
    circle = '#FFF';
    path = 'none';
  } else if (variant === 'gray') {
    circle = '#6D6D6D';
  }

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <circle cx='12' cy='12' r='8.5' fill={circle} stroke={circle} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.4373 10.2446L11.2617 15.4746L7.56274 11.7367L8.56231 10.7475L11.2617 13.4754L15.4377 9.25543L16.4373 10.2446Z'
        fill={path}
      />
    </svg>
  );
}

export default SuccessFillIcon;
